<template>
  <div id="bscbo1">
    <div class="box">
      <div id="bscbo1div" style="height:100%"></div>
    </div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from 'echarts';
import { AREA_LIST, BU_LIST, MONTH_NAME } from '../mainPage/area_bu'

export default {
  name: 'bscbo1',
  data() {
    return {
      // 需要合并对象，样式
      legendColor: false,
      mm: 5,
      dataset: [-10, 5, -3],
      NowYearTargetValue: []
    };
  },
  created() {},
  mounted() {
    //   mounted 函数表示已经DOM渲染完成
    this.NowYearTargetValue = []
    MONTH_NAME.forEach(x => {
      this.NowYearTargetValue.push(x.label)
    })
  },
  methods: {
    refreshChart(chartData) {
      const data1 = []
      const data2 = []
      const data3 = []
      const titleData = []
      this.dataset = []
      if (chartData !== undefined) {
        for (let i = 0; i < chartData.length; i++) {
          /*
          titleData.push(chartData[i].BU)
          data1.push(chartData[i].LastYearPracticalValue)
          data2.push(chartData[i].PracticalValue)
          data3.push(chartData[i].PlanValue)
          this.NowYear = chartData[i].Year
          */
          let lastValue = 0.0
          try {
            lastValue = parseFloat(chartData[i].LastYearPracticalValue)
          } catch { }
          let currValue = 0.0
          try {
            currValue = parseFloat(chartData[i].PracticalValue)
          } catch { }
          let diffValue = 0
          if (currValue > 0) {
            diffValue = ((currValue - lastValue) / lastValue) * 100
            diffValue = Math.round(diffValue * Math.pow(10, 2)) / Math.pow(10, 2)
          }
          data2.push(diffValue)
        }
      }
      this.dataset = data2

      var myChart = echarts.init(document.getElementById('bscbo1div'));

      var option = {
        title: {
          text: this.locale('Reduce tce/¥10K YOY%','万元产值能耗同比下降YOY%'),
          textStyle: {
            color: '#fff',
            fontSize: 24
          },
          y: 10,
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: function(params) {
            var str = '';
            str += params[0].name;
            var now = new Date();
            for (var i = 0; i < params.length; i++) {
              str += '<br/>' + params[i].seriesName + ':' + params[i].value;
            }
            return str;
          }
        },
        grid: {
          left: '6%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.NowYearTargetValue,
            axisTick: {
              alignWithLabel: true,
              interval: 0
            },
            axisLabel: {
              interval: 0,
              color: '#ffffff',
              fontSize: 16
            },
            axisLine: {
              // 轴线
              lineStyle: {
                color: '#7f8fa4'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '%',
            nameTextStyle: {
              color: '#ffffff',
              fontSize: 16
            },
            boundaryGap: [0, '10%'],
            axisLabel: {
              color: '#ffffff',
              fontSize: 16
            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#7f8fa4'
              }
            }
          }
        ],
        series: [
          {
            name: this.locale('YOY%','同比%'),
            type: 'bar',
            itemStyle: {
              normal: {
                //color: '#61a0a8'
                color: function(params) {
                  if (params.data >= 0)
                    return '#FFC000'
                  else
                    return '#00B050'
                }
              }
            },
            barWidth: '30%',
            data: this.dataset,
            label: {
              color: '#eee'
            }
          }
        ]
      };
      // 5：展示数据
      myChart.setOption(option);
    }
  }
};
</script>

<style lang="less" scope >
#bscbo1 {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  // border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
  .box {
    height: 100%;
    width: 100%;
  }
}
</style>
